import { Box, styled } from '@mui/material';
import { BoxProps } from '@mui/material/Box/Box';

export const Container = styled(Box)<BoxProps>`
  //border: 1px solid gray;
  background-color: white;

  -webkit-box-shadow: 10px 10px 5px 0px rgba(0, 0, 0, 0.5);
  -moz-box-shadow: 10px 10px 5px 0px rgba(0, 0, 0, 0.5);
  box-shadow: 10px 10px 5px 0px rgba(0, 0, 0, 0.5);
`;

export const ContainerFormField = styled('div')`
  margin-bottom: 15px;
  padding: 0 15px;
`;

export const WrapSection = styled(Box)`
  padding: 15px 0 0 0;
`;
